import { Common } from '../../middleware/index'

interface NoteParam {
    page:number;
    size:number;
}

export class UserShow extends Common {
    public get request(){
        return (this as any).$axios
    }
    public get commit(){
        return (this as any).$store.commit
    }
    public async getNoteList(params:NoteParam){
        const res = (await this.request.post('/acura/shareMessage/page',params)) as any;
        return res;
    }
}